import { Col, Row, Space } from 'antd';
import { CoverageConfig } from './Coverage';
import { CoverageCities } from './CoverageCities';
import { ManageLogo } from './Logo';
import { SearchRange } from './SearchRange';
import { WorkspaceName } from './WorkspaceName';
// import { BatchingConfig } from './Batching';

const General = () => (
    <Row gutter={[48, 32]} justify="space-between" align="top">
        <Col xl={12} xs={24}>
            <Space direction="vertical" size={24} style={{ width: '100%' }}>
                <WorkspaceName />
                <CoverageConfig />
                <SearchRange />
                {/* <BatchingConfig /> */}
            </Space>
        </Col>
        <Col xl={12} xs={24}>
            <Space direction="vertical" size={24} style={{ width: '100%' }}>
                <CoverageCities />
                <ManageLogo />
            </Space>
        </Col>
    </Row>
);

export default General;
